(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-review-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('vpa-review-carousel')) return;
    const loaderUrl = 'https://cdn.productreview.com.au/assets/widgets/loader.js';
    let loaderPromise;
    const loadVendor = brandId => {
      if (window.ProductReview?.use) return Promise.resolve(window.ProductReview);
      if (loaderPromise) return loaderPromise;
      window.__productReviewSettings = window.__productReviewSettings || { brandId };
      loaderPromise = new Promise((resolve, reject) => {
        let script = Array.from(document.scripts).find(node => node.src === loaderUrl);
        const owned = !script;
        if (owned) {
          script = document.createElement('script');
          script.src = loaderUrl;
          script.async = true;
        }
        let poll, timeout;
        const finish = error => {
          clearInterval(poll);
          clearTimeout(timeout);
          script.removeEventListener('error', failed);
          if (error) {
            if (owned) script.remove();
            reject(error);
          } else resolve(window.ProductReview);
        };
        const failed = () => finish(new Error('ProductReview loader failed'));
        script.addEventListener('error', failed, { once: true });
        poll = setInterval(() => { if (window.ProductReview?.use) finish(); }, 50);
        timeout = setTimeout(failed, 15000);
        if (owned) document.head.append(script);
      }).catch(error => { loaderPromise = null; throw error; });
      return loaderPromise;
    };

    class ReviewCarousel extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.target = this.querySelector('[data-review-target]');
        this.button = this.querySelector('[data-review-load]');
        this.status = this.querySelector('[data-review-status]');
        this.fallback = this.querySelector('[data-review-fallback]');
        if (!this.target || !this.button) return;
        this.button.hidden = false;
        this.button.disabled = false;
        this.addEventListener('click', event => {
          if (event.target.closest('[data-review-load]')) this.load();
        }, { signal: this.controller.signal });
        this.observer = new MutationObserver(() => {
          if (this.target.querySelector('[data-slider-scroller] > *')) {
            this.setupNavigation();
            clearTimeout(this.renderTimeout);
            this.fallback.hidden = true;
            this.removeAttribute('aria-busy');
          }
        });
        this.observer.observe(this.target, { childList: true, subtree: true });
        if (this.hasAttribute('eager') || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
          this.load();
        } else {
          this.intersection = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) this.load();
          }, { rootMargin: '600px 0px' });
          this.intersection.observe(this);
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.intersection?.disconnect();
        this.observer?.disconnect();
        clearTimeout(this.renderTimeout);
        this.api?.destroy?.('reviews-carousel', this.options);
        this.resizeObserver?.disconnect();
        this.scroller = null;
        this.querySelector('[data-review-dots]').replaceChildren();
        this.querySelector('[data-review-footer]').hidden = true;
        this.api = null;
        this.loading = false;
        this.target?.replaceChildren();
        if (this.fallback) this.fallback.hidden = false;
      }

      setupNavigation() {
        const scroller = this.target.querySelector('[data-slider-scroller]');
        if (!scroller || this.scroller === scroller) return;
        this.scroller = scroller;
        const dots = this.querySelector('[data-review-dots]');
        const footer = this.querySelector('[data-review-footer]');
        footer.hidden = false;
        const update = () => {
          const card = scroller.firstElementChild;
          if (!card || !scroller.clientWidth) return;
          const perPage = Math.max(1, Math.round(scroller.clientWidth / card.getBoundingClientRect().width));
          const pages = Math.ceil(scroller.children.length / perPage);
          const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
          const current = atEnd ? pages - 1 : Math.round(scroller.scrollLeft / scroller.clientWidth);
          if (dots.children.length !== pages) {
            dots.replaceChildren(...Array.from({ length: pages }, (_, index) => {
              const button = document.createElement('button');
              button.type = 'button';
              button.setAttribute('aria-label', this.dataset.pageLabel.replace('[number]', index + 1));
              button.addEventListener('click', () => {
                scroller.scrollTo({ left: index * scroller.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
              }, { signal: this.controller.signal });
              return button;
            }));
          }
          dots.hidden = pages < 2;
          Array.from(dots.children).forEach((button, index) => button.setAttribute('aria-current', String(index === current)));
          this.target.querySelectorAll('[data-slider-arrow-prev] > *, [data-slider-arrow-next] > *').forEach(arrow => {
            const previous = arrow.parentElement.hasAttribute('data-slider-arrow-prev');
            arrow.setAttribute('role', 'button');
            arrow.setAttribute('tabindex', '0');
            arrow.setAttribute('aria-label', arrow.querySelector('title')?.textContent || '');
            arrow.setAttribute('aria-disabled', String(previous ? scroller.scrollLeft <= 1 : atEnd));
          });
        };
        scroller.addEventListener('scroll', update, { passive: true, signal: this.controller.signal });
        this.target.addEventListener('keydown', event => {
          const arrow = event.target.closest('[data-slider-arrow-prev] > *, [data-slider-arrow-next] > *');
          if (arrow && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            arrow.click();
          }
        }, { signal: this.controller.signal });
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(scroller);
        update();
      }

      async load() {
        if (this.loading || !this.isConnected) return;
        const signal = this.controller.signal;
        this.loading = true;
        this.intersection?.disconnect();
        this.button.disabled = true;
        this.status.textContent = this.dataset.loading;
        this.setAttribute('aria-busy', 'true');
        const failed = () => {
          if (signal.aborted) return;
          this.loading = false;
          this.button.disabled = false;
          this.fallback.hidden = false;
          this.status.textContent = this.dataset.error;
          this.removeAttribute('aria-busy');
        };
        try {
          const api = await loadVendor(this.dataset.brandId);
          if (signal.aborted) return;
          this.api?.destroy?.('reviews-carousel', this.options);
          this.api = api;
          this.options = {
            container: `#${this.target.id}`,
            configuration: {
              renderInAnIframe: false,
              renderSubmissionInCard: true,
              displaySubmissionAuthorAvatar: true,
              numberOfReviews: 12,
              overallRatingPosition: 'bottom',
              submissionContentAlignment: 'start',
              submissionMaxLength: 260,
              size: 'default',
              theme: { preset: 'light', mainColor: '#4c7d43' }
            },
            identificationDetails: { type: 'single', strategy: 'from-internal-entry-id', identifier: this.dataset.entryId }
          };
          this.renderTimeout = setTimeout(failed, 15000);
          api.use('reviews-carousel', this.options);
        } catch (error) { failed(); }
      }
    }
    customElements.define('vpa-review-carousel', ReviewCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
